import React from 'react'
import { BenchmarkThresholds } from '../../domain/Benchmark'

interface Props {
    benchmark: BenchmarkThresholds
    averageResponse: number
}

export class TransactionBenchmarkIndicator extends React.PureComponent<Props> {
    public detect = (averageResponse, thresholds: BenchmarkThresholds): null | { color: string; section: string; icon: string } => {
        if (averageResponse < thresholds.top10Percent) {
            return { color: '#FFD700', section: 'best 10%', icon: 'fa-trophy' }
        }

        if (averageResponse < thresholds.top25Percent) {
            return { color: '#838996', section: 'best 25%', icon: 'fa-trophy' }
        }

        if (averageResponse > thresholds.worst10Percent) {
            return { color: '#FF0000', section: 'worst 10%', icon: 'fa-exclamation-triangle' }
        }

        if (averageResponse > thresholds.worst25Percent) {
            return { color: '#FFA500', section: 'worst 25%', icon: 'fa-exclamation-triangle' }
        }

        return null
    }

    public render() {
        const { benchmark, averageResponse } = this.props

        const detected = this.detect(averageResponse, benchmark)

        if (!detected) {
            return null
        }
        const { color, section, icon } = detected

        return (
            <a
                href={benchmark.reportUrl}
                target="_blank"
                className="tw-pl-4 tw-tooltip tw-tooltip-dataText tw-tooltip--right"
                data-tooltip-text={
                    'Average response time of ' +
                    Math.round(averageResponse) +
                    ' ms is in the ' +
                    section +
                    ' of ' +
                    benchmark.framework +
                    ' shops in ' +
                    benchmark.reportLabel +
                    ' benchmark report'
                }
                rel="noreferrer"
            >
                <span className={'fa ' + icon} style={{ color: color }} />
            </a>
        )
    }
}
